import { ManualField } from '../ManualFieldInput/ManualFieldInput.types';

export const ADDRESS_FIELDS: ManualField[] = [
  { field: 'unit', placeholderKey: 'unit' },
  { field: 'building', placeholderKey: 'building' },
  { field: 'street', placeholderKey: 'street' },
  { field: 'city', placeholderKey: 'city' },
  { field: 'postalCode', placeholderKey: 'postalCode' },
];
